import Vue from 'vue';

var cases = [2, 0, 1, 1, 1, 2];

var dict = {
	'newsSubscribe': {
		'en': 'subscribe to news',
		'ru': 'Подписаться на новости'
	},

	'copyright': {
		'en': 'Confectionery products of Morozov',
		'ru': '«Кондитерские изделия Морозова»'
	},

	//

	'product': {
		'en': ['product', 'products'],
		'ru': ['товар', 'товара', 'товаров']
	},

	'recipe': {
		'en': ['recipe', 'recipes'],
		'ru': ['рецепт', 'рецепта', 'рецептов']
	},

	'vacancy': {
		'en': ['vacancy', 'vacancies'],
		'ru': ['вакансия', 'вакансии', 'вакансий']
	},

	//

	'taste': {
		'en': 'by taste',
		'ru': 'по вкусу'
	},

	'gram': {
		'en': 'g.',
		'ru': 'г.'
	},

	'piece': {
		'en': ['piece', 'pieces'],
		'ru': ['штука', 'штуки', 'штук']
	},

	'pack': {
		'en': ['pack', 'packs'],
		'ru': ['упаковка', 'упаковки', 'упаковок']
	},

	'pinch': {
		'en': ['pinch', 'pinches'],
		'ru': ['щепотка', 'щепотки', 'щепоток']
	},

	'ml': {
		'en': 'ml.',
		'ru': 'мл.'
	},

	'teaspoon': {
		'en': ['teaspoon', 'teaspoons'],
		'ru': ['чайная ложка', 'чайных ложки', 'чайных ложек']
	},

	'tablespoon': {
		'en': ['tablespoon', 'tablespoons'],
		'ru': ['столовая ложка', 'столовых ложки', 'столовых ложек']
	},

	'glass': {
		'en': ['glass', 'glasses'],
		'ru': ['стакан', 'стакана', 'стаканов']
	},

	//

	'searchCountTitle': {
		'en': 'We found {{count}} matching',
		'ru': '\u041C\u044B \u043D\u0430\u0448\u043B\u0438 {{count}} \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443'
	},

	'searchEmptyTitle': {
		'en': 'Unfortunately, we did not find the product according to your request',
		'ru': 'К сожалению, мы не нашли товар по вашему запросу'
	},

	//

	'filterAll': {
		'en': 'All',
		'ru': 'Все'
	},

	//

	'submitSend': {
		'en': 'Send',
		'ru': 'Отправить'
	},

	'submitWait': {
		'en': 'Wait',
		'ru': 'Подождите'
	},

	'submitSuccess': {
		'en': 'Success',
		'ru': 'Отправлено'
	},

	//

	'catalogCategories': {
		'en': 'Product categories',
		'ru': 'Категории'
	},

	'catalogBrands': {
		'en': 'Product brands',
		'ru': 'Бренды'
	},

	'catalogTypes': {
		'en': 'Product types',
		'ru': 'Виды'
	},

	'filterBtn': {
		'en': 'Filter',
		'ru': 'Фильтр'
	},

	'filterReset': {
		'en': 'Reset filter',
		'ru': 'Сбросить фильтр'
	},

	'filterSelected': {
		'en': 'Selected filters',
		'ru': 'Выбранные фильтры'
	},

	'filterCut': {
		'en': 'Collapse',
		'ru': 'Свернуть'
	},

	'filterUncut': {
		'en': 'Show',
		'ru': 'Показать ещё'
	}
};

var toLocale = function toLocale(key, count) {
	var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ru';


	if (!key || !(key in dict)) return '';

	var value = dict[key];

	if (typeof value[lang] === 'string') {
		return value[lang];
	}

	if (lang === 'en') {
		return count > 1 ? value.en[1] : value.en[0];
	} else {
		return value.ru[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
	}
};

Vue.use({
	install: function install(Vue) {
		Vue.lang = toLocale;
		Vue.prototype.$lang = toLocale;
	}
});

export default toLocale;


//////////////////
// WEBPACK FOOTER
// ./plugins/lang.js
// module id = ./plugins/lang.js
// module chunks = 5